import React, { useEffect, useState } from 'react';
import '../../landingAssets/css/bootstrap.min.css';
import '../../landingAssets/css/custom-animated.css';
import '../../landingAssets/css/default.css';
import '../../landingAssets/css/font-awesome.min.css';
import '../../landingAssets/css/magnific-popup.css';
import '../../landingAssets/css/magnific.dark.css';
import '../../landingAssets/css/magnific.rtl.css';
import '../../landingAssets/css/main.css';
import '../../landingAssets/css/style.css';
import Loader from '../landing/loder/Loader.jsx';
import Drawer from '../landing/Mobile/Drawer.jsx';
import useToggle from '../landing/Hooks/useToggle.js';
import HomeOneHeader from '../landing/Home/HomeOneHeader.jsx';
import FaqHomeOne from '../landing/Home/FaqHomeOne.jsx';
import ProjectHomeOne from '../landing/Home/ProjectHomeOne.jsx';
import FooterHomeOne from '../landing/Home/FooterHomeOne.jsx';
import BackToTop from '../landing/BackToTop.jsx';
import CartPage from './CartPage.js';
import { useSelector,useDispatch } from 'react-redux';

function LandingCartIndex() {
  const skipOrGetStart = useSelector((state)=>state.skipGet);
  console.log("skipOrGetStart",skipOrGetStart);
  const [loading, setLoading] = useState(true);
  const [drawer, drawerAction] = useToggle(false);
  
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {loading && (
        <div className={`appie-loader ${loading ? 'active' : ''}`}>
          <Loader />
        </div>
      )}
      <div className={`appie-visible ${loading === false ? 'active' : ''}`}>
        <Drawer drawer={drawer} action={drawerAction.toggle} />
        <HomeOneHeader action={drawerAction.toggle}/>
        <CartPage skipOrGetStart={skipOrGetStart}/>
        <FaqHomeOne />
        <ProjectHomeOne />
        <FooterHomeOne />
        <BackToTop />
      </div>
    </>
  );
}

export default LandingCartIndex;
